import React, { Component } from "react";
import PropTypes from "prop-types";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { activeFormatter } from "Utils/Acciones/Acciones";
import { tableOptions } from "Utils/tableOptions";
import { Link } from "react-router-dom";
import Toolbar from "Utils/Toolbar/Toolbar";
import { RenderMoneda } from "Utils/renderField/renderTableField";
import { icons } from "icons";
import LoadMask from "Utils/LoadMask/LoadMask";
import { api } from "api";
import { formatoCodigoBarras } from "../../Utils/FormatoDataTable/FormatoData";
// const imgDefault = require("../../../../../assets/img/icons/uploading-img.png")
import "./ProductoListado.css";
import "./sin_productos";
import ModalImportar from "./ModalImportar";

function formatoAvatar(cell, row) {
    if (cell !== "") {
        return (
            <img
                className="imagen-sm"
                src={cell}
                alt=""
                style={{ width: "38px", height: "38px" }}
            />
        );
    } else {
        return (
            <img
                className="imagen-sm"
                src={icons.img_default}
                alt=""
                style={{ width: "38px", height: "38px" }}
            />
        );
    }
}

const formatoVistaImprimir = (id) => {
    return (
        <Link to={`/productos/imprimir_codigos/${id}/`}>
            {/* <img className="action-img" title="Imprimir códigos" src={icons.imprimir} alt="Imprimir códigos" style={{maxWidth: '22px'}}/> */}
            <em
                className="fa fa-ticket"
                title="Imprimir códigos"
                style={{ fontSize: "1.6em" }}
            />
        </Link>
    );
};

class Detalle extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        loader: PropTypes.bool,
    };

    static defaultProps = {
        loader: false,
    };

    constructor(props) {
        super(props);
        this.fileInputRef = React.createRef();
    }

    state = {
        familiaSeleccionada: null,
        menuAbiertoId: null,
        mostrarModalExcel: false,
        primeraCargaRealizada: false,
    };

    handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        //resetear inmediatamente
        event.target.value = "";

        const formData = new FormData();
        formData.append("file", file);

        this.props.importar_productos(formData);
    };

    // función para abrir/cerrar menú
    abrirMenu = (id) => {
        this.setState((prev) => ({
            menuAbiertoId: prev.menuAbiertoId === id ? null : id,
        }));
    };

    manejarContinuar = (datos, archivo) => {
        this.props.history.push({
            pathname: "/productos/previsualizar",
            state: {
                datosExcel: datos,
                archivoOriginal: archivo
            }
        });
    };


    setFamilia = (familia) => {
        console.log("familia seleccionada: ", familia);
        this.props.setFamiliaSeleccionada(familia);
        this.setState({ familiaSeleccionada: familia }, () => {
            const { listarProductos, page } = this.props;
            listarProductos(page, familia && familia.id ? familia.id : null);
        });
    };

    componentDidMount() {
        this.props.listarProductos(this.props.page);
        // Marcamos que ya se inició la petición inicial
        this.setState({ primeraCargaRealizada: true });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.familiaSeleccionada !== this.state.familiaSeleccionada) {
            const { listarProductos, page } = this.props;
            const familiaId =
                this.state.familiaSeleccionada &&
                this.state.familiaSeleccionada.id
                    ? this.state.familiaSeleccionada.id
                    : null;
            listarProductos(page, familiaId);
        }
    }

    isExpandableRow(row) {
        return true;
    }

    // function priceFormatter(cell, row) {
    //     console.log("DATOS FRACCIONES: ", cell)
    //     return (
    //         <div className="text-right">${cell}</div>
    //     )
    //     // return `<i class='glyphicon glyphicon-usd'></i> ${cell}`;
    // }

    expandComponent(row) {
        return (
            // pagination={data.sucursales.length > 10}
            <BootstrapTable data={row.fracciones} remote={false}>
                <TableHeaderColumn dataField="nombre" dataSort={false}>
                    Presentación
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="codigos_barras"
                    isKey={true}
                    dataSort={false}
                    dataFormat={formatoCodigoBarras}
                >
                    Código de barras
                </TableHeaderColumn>
                <TableHeaderColumn
                    dataField="precio"
                    dataSort={false}
                    dataFormat={(cell) => <RenderMoneda monto={cell} />}
                >
                    Precio
                </TableHeaderColumn>
                {/* <TableHeaderColumn width="20%" dataField="id" dataAlign="center"
                                dataFormat={activeFormatter({ver: '/sucursal/detalle', editar: '/sucursal/editar', eliminar})}>Acciones</TableHeaderColumn> */}
            </BootstrapTable>
            // <BSSucursal data={row} />
        );
    }

    expandColumnComponent({ isExpandableRow, isExpanded }) {
        let content = "";

        if (isExpandableRow) {
            if (isExpanded) {
                return (
                    <div className="text-center">
                        <em className="fa fa-caret-down" />
                    </div>
                );
            } else {
                return (
                    <div className="text-center">
                        <em className="fa fa-caret-right" />
                    </div>
                );
            }
        } else {
            content = " ";
        }
        return <div> {content} </div>;
    }

    renderEmptyState() {
        return (
            <div className="empty-state-container text-center">
                <div className="empty-state-icon-main">
                    <div className="icon-circle">
                        <em className="fa fa-info"></em>
                    </div>
                </div>
                <h3 className="empty-state-title">Aun no tienes productos</h3>
                <p className="empty-state-subtitle">Selecciona la forma en que deseas cargar tus productos</p>
                
                <div className="empty-state-options">
                    <Link to="/productos/crear/" className="empty-state-card">
                        <div className="card-icon">
                            <em className="fa fa-archive"></em>
                        </div>
                        <span>Cargar productos manualmente</span>
                    </Link>

                    <div 
                        className="empty-state-card" 
                        onClick={() => this.setState({ mostrarModalExcel: true })}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="card-icon">
                            <em className="fa fa-file-excel-o"></em>
                        </div>
                        <span>Cargar productos desde documento excel</span>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        //
        const { estado_descarga } = this.props;

        // state
        const { data, loader, page, conf_tipo_negocio } =
            this.props;

        // bind
        const { listarProductos, eliminar, desactivar, sortChange, descargarListado, importar_productos,search } =
            this.props;

        // local
        const options = {
            ...tableOptions,
            noDataText: loader ? "Cargando..." : (search ? "No se encontraron productos coincidentes" : tableOptions.noDataText),
            onPageChange: listarProductos,
            onSortChange: sortChange,
            page,
        };


        const getFamilias = (search) => {
            return api
                .get("familia", { search })
                .then((data) => {
                    return { options: data.results };
                })
                .catch(() => ({ options: [] }));
        };

        // Lógica para decidir qué mostrar
        const tieneProductos = data && data.results && data.results.length > 0;

        const esBusquedaVacia = !tieneProductos && (search || this.state.familiaSeleccionada);

        // Si no hay productos y terminó de cargar, mostramos el Empty State
        if (!loader && !tieneProductos && !esBusquedaVacia) {
            return (
                <div className="container-fluid">
                    {this.renderEmptyState()}
                    {/* Mantener el modal aquí por si el usuario decide cargar Excel desde el empty state */}
                    <ModalImportar 
                        show={this.state.mostrarModalExcel}
                        onHide={() => this.setState({ mostrarModalExcel: false })}
                        alContinuar={(datos, archivo) => this.manejarContinuar(datos, archivo)}
                        onProcesarArchivo={(archivo, callback) => {
                            const formData = new FormData();
                            formData.append("file", archivo);
                            this.props.previsualizar_productos(formData, callback);
                        }}
                        onFinalizar={(datos) => {
                            this.props.confirmar_importacion(datos);
                            this.setState({ mostrarModalExcel: false });
                        }}
                    />
                </div>
            );
        }

        return (
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    
                    {/* --- SECCIÓN DE BOTONES SUPERIORES --- */}
                    <div className="mt">
                        <Link
                            className="btn btn-primary mb-sm-10"
                            to="/productos/crear/"
                        >
                            <em className="fa fa-plus"></em> Agregar Producto
                        </Link>

                        <input
                            type="file"
                            accept=".xlsx,.xls"
                            style={{ display: "none" }}
                            ref={this.fileInputRef}
                            onChange={this.handleFileChange}
                        />
                        &nbsp;&nbsp;
                        <button
                            className="btn btn-tertiary btn-excel-ing"
                            onClick={() => this.setState({ mostrarModalExcel: true })}
                        >
                            <em className="fa fa-upload"></em> Cargar catálogo de productos
                        </button>

                        {/* Al final del render, antes del último </div> */}
                        <ModalImportar 
                            show={this.state.mostrarModalExcel}
                            onHide={() => this.setState({ mostrarModalExcel: false })}
                            alContinuar={(datos, archivo) => this.manejarContinuar(datos, archivo)}
                            onProcesarArchivo={(archivo, callback) => {
                                // Aquí envías el archivo a tu API para procesarlo y obtener la vista previa
                                const formData = new FormData();
                                formData.append("file", archivo);
                                
                                // Supongamos que tu acción 'importar_productos' ahora devuelve los datos
                                // o maneja un callback para la previsualización.
                                this.props.previsualizar_productos(formData, callback);
                            }}
                            onFinalizar={(datos) => {
                                // Esta función se llama cuando presionan "Finalizar" en el paso 2
                                this.props.confirmar_importacion(datos);
                                this.setState({ mostrarModalExcel: false });
                            }}
                        />
                    </div>

                    <div className="card-productos">
                        <div className="row align-items-center mb-3">
                            <div className="col-md-4">
                                <h3 className="m-0" style={{ fontWeight: 'bold' }}>Productos</h3>
                            </div>
                            <div className="col-md-8 d-flex justify-content-end align-items-center">
                                {/* Botón Descargar Listado (Estilo Gris Claro) */}
                                <button
                                    className="btn btn-light mr-2"
                                    style={{ borderRadius: '20px', backgroundColor: '#ebebeb' }}
                                    disabled={estado_descarga}
                                    onClick={() => descargarListado()}
                                >
                                    <em className={`fa ${estado_descarga ? "fa-spinner fa-pulse" : "fa-download"}`}></em>
                                    &nbsp;Descargar Listado
                                </button>

                                <Toolbar
                                    familias={getFamilias()}
                                    buscarFamilia={this.props.buscarFamilia}
                                    search={this.props.search}
                                    buscar={this.props.buscar}
                                    searchFamilia={this.props.searchFamilia}
                                    filtroFamilia={true}
                                    getFamilias={getFamilias}
                                    setFamilia={this.setFamilia}
                                    familiaSeleccionada={
                                        this.state.familiaSeleccionada
                                    }
                                />
                            </div>
                        </div>    

                        <LoadMask loading={loader} dark blur>
                            <BootstrapTable
                                data={loader ? [] : data.results}
                                fetchInfo={{ dataTotalSize: data.count }}
                                options={options}
                                expandableRow={this.isExpandableRow}
                                expandComponent={this.expandComponent}
                                expandColumnOptions={{
                                    expandColumnVisible: true,
                                    expandColumnComponent:
                                        this.expandColumnComponent,
                                    columnWidth: 50,
                                }}
                                striped
                                hover
                                remote
                                pagination
                            >
                                <TableHeaderColumn
                                    dataField="img_cropped"
                                    width="10%"
                                    dataFormat={formatoAvatar}
                                    dataAlign="center"
                                />
                                {/* <TableHeaderColumn isKey dataSort dataField='id'>ID</TableHeaderColumn> */}
                                <TableHeaderColumn dataField="nombre" dataSort>
                                    Nombre
                                </TableHeaderColumn>
                                <TableHeaderColumn dataField="marca" dataSort>
                                    Marca
                                </TableHeaderColumn>
                                {conf_tipo_negocio === "Joyeria" && (
                                    <TableHeaderColumn
                                        dataField="kilataje"
                                        dataSort
                                    >
                                        Kilataje
                                    </TableHeaderColumn>
                                )}

                                {conf_tipo_negocio === "Joyeria" && (
                                    <TableHeaderColumn
                                        dataField="peso"
                                        dataSort
                                    >
                                        Peso
                                    </TableHeaderColumn>
                                )}
                                <TableHeaderColumn
                                    dataField="id"
                                    isKey
                                    dataAlign="center"
                                    width="20%"
                                    dataFormat={activeFormatter({
                                        ver: "/productos/detalle",
                                        editar: "/productos/editar",
                                        eliminar,
                                        desactivar,
                                        adicional: formatoVistaImprimir,
                                        modoMenu: true, 
                                        menuAbiertoId: this.state.menuAbiertoId,
                                        abrirMenu: this.abrirMenu,
                                         descontinuarProducto: this.props.descontinuar,
                                    })}
                                >
                                    Acciones
                                </TableHeaderColumn>
                                {/* <TableHeaderColumn dataField='id' dataAlign="center" width="20%"
                            dataFormat={activeFormatter({ver:'/productos/detalle', editar: '/productos/editar/', eliminar: eliminar })}>Acciones</TableHeaderColumn> */}
                                {/* <TableHeaderColumn dataField='id' dataAlign="center" width="20%"
                            dataFormat={activeFormatter({ editar: '/productos/editar', eliminar: eliminar, ver:'/productos/detalle' })}>Acciones</TableHeaderColumn> */}
                            </BootstrapTable>
                        </LoadMask>
                    </div>
                </div>
            </div>
        );
    }
}

export default Detalle;